module.exports = __webpack_public_path__ + "static/media/fal_fal_saf_lad.183d6b59.png";